import React, { type PropsWithChildren } from 'react';

import { TransparentModal } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModal = (props: GroupOrderModalProps) => {
  const { children, onClose } = props;

  return (
    <TransparentModal size="medium" fitHeight onClose={onClose}>
      {children}
    </TransparentModal>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderModalProps = PropsWithChildren<{
  onClose: () => void;
}>;
